import React from "react";
import InquiryForm from "@/components/InquiryForm";

const HERO_IMAGE = `${process.env.REACT_APP_BACKEND_URL}/api/static/hero.png`;

export default function Hero() {
    return (
        <section
            data-testid="hero-section"
            className="relative"
        >
            <div className="relative grid w-full grid-cols-1 gap-10 pb-16 pl-6 pr-0 pt-4 md:pl-10 md:pb-24 lg:grid-cols-12 lg:gap-14">
                {/* LEFT: copy + form */}
                <div className="relative z-10 lg:col-span-5 lg:pl-4 xl:pl-10">
                    {/* Headline */}
                    <div className="enc-reveal delay-2 mt-4 max-w-xl md:mt-8">
                        <p className="text-xs uppercase tracking-[0.4em] text-brand-goldSoft">
                            Insurance that
                        </p>
                        <h1 className="mt-4 font-serif text-5xl font-bold leading-[0.95] text-brand-ivory sm:text-6xl md:text-7xl">
                            Protects what
                            <br />
                            <span className="gold-text">you've built.</span>
                        </h1>
                        <p className="mt-6 text-pretty text-lg text-brand-muted">
                            <span className="whitespace-nowrap">Home.&nbsp;Life.&nbsp;Business.</span>{" "}
                            <span className="text-brand-ivory">
                                Peace of mind that lasts.
                            </span>
                        </p>
                        <div className="gold-hairline mt-8 w-48" />
                    </div>

                    {/* Form */}
                    <div className="enc-reveal delay-4 mt-10 max-w-xl">
                        <div className="mb-6">
                            <h3
                                data-testid="form-heading"
                                className="font-serif text-2xl tracking-wide text-brand-gold2 sm:text-3xl"
                            >
                                Tell us what you need.
                            </h3>
                            <p className="mt-2 text-xs uppercase tracking-[0.3em] text-brand-muted">
                                A licensed agent will contact you.
                            </p>
                        </div>
                        <InquiryForm />
                    </div>
                </div>

                {/* RIGHT: hero image — full bleed to right edge */}
                <div className="relative lg:col-span-7">
                    <div className="enc-reveal delay-3 relative">
                        <div className="radial-gold absolute -inset-6 rounded-[2rem] blur-xl" />
                        <div className="relative overflow-hidden rounded-l-[1.25rem] border border-r-0 border-[rgba(212,175,55,0.25)] shadow-[0_40px_80px_-30px_rgba(0,0,0,0.8)]">
                            <img
                                data-testid="hero-image"
                                src={HERO_IMAGE}
                                alt="Family enjoying home protected by Endurance Casualty Insurance"
                                className="h-[560px] w-full object-cover object-center md:h-[780px] lg:h-[880px] xl:h-[960px]"
                                loading="eager"
                            />
                            {/* Gold hairline frame */}
                            <div className="pointer-events-none absolute inset-2 rounded-l-[1rem] border border-r-0 border-[rgba(212,175,55,0.25)]" />
                            {/* Soft bottom gradient for mood */}
                            <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/4 bg-gradient-to-t from-brand-bg/70 via-brand-bg/20 to-transparent" />
                        </div>

                        {/* Floating caption tag */}
                        <div
                            data-testid="hero-caption"
                            className="enc-reveal delay-5 absolute -bottom-5 left-6 right-10 hidden items-center justify-between gap-4 rounded-xl border border-[rgba(212,175,55,0.35)] bg-[#0b0e13]/90 px-5 py-4 backdrop-blur-md md:flex"
                        >
                            <div>
                                <p className="text-[10px] uppercase tracking-[0.3em] text-brand-goldSoft">
                                    Licensed where required
                                </p>
                                <p className="mt-1 font-serif text-xl text-brand-ivory">
                                    Coverage tailored to your state.
                                </p>
                            </div>
                            <a
                                href="tel:+18559007405"
                                className="shrink-0 rounded-full border border-brand-gold/60 px-4 py-2 text-xs uppercase tracking-[0.2em] text-brand-gold2 transition-colors hover:bg-brand-gold hover:text-brand-bg"
                            >
                                855.900.7405
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
